import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { DireccionAdministrativaService } from '../../../services/service.index';
declare var toastr;

@Component({
  selector: 'app-direccion-administrativa',
  templateUrl: './direccion-administrativa.component.html',
  styles: []
})
export class DireccionAdministrativaComponent implements OnInit {


  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourcePR: any[];
  model: any = {
    id: 0,
    codigo: '',
    descripcion: '',
    activo: true
  };
  daID: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;

  constructor(private _ss: DireccionAdministrativaService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getDireccionAdministrativas();
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, descripcion: false };
  }

  getDireccionAdministrativas() {
    this._ss.getDireccionAdministrativa().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourcePR = result.data;
        } else {
          this.dataResourcePR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.descripcion = '';
    this.model.activo = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.descripcion = data.descripcion;
    this.model.activo = data.activo;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveDireccionAdministrativa() {
    this.hasError = { codigo: false, descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._ss.postDireccionAdministrativa(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getDireccionAdministrativas();
              this.popupVisibleAdd = false;
              toastr.success('Dirección Administrativa adicionada exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._ss.putDireccionAdministrativa(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getDireccionAdministrativas();
              this.popupVisibleAdd = false;
              toastr.success('Dirección Administrativa modificada exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.daID = id;
    this.popupVisibleDel = true;
  }

  deleteDireccionAdministrativa() {
    this._ss.deleteDireccionAdministrativa(this.daID).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getDireccionAdministrativas();
          this.popupVisibleDel = false;
          toastr.success('Registro eliminado correctamente.');
        } else if (result.status == 201) {
          this.getDireccionAdministrativas();
          this.popupVisibleDel = false;
          toastr.warning(result.data);
        }
        else {
          toastr.warning("otro");
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }
}
